<div class="row w-100 d-none d-lg-flex p-0 align-items-center"
  [ngClass]="{'text-primary fw-bold ': actorInSendgroup.grouped, 'cursor-pointer': !groupedActor }"
  (click)="!actorInSendgroup.grouped ? openEmailPreview() : null">
  <div class="col-4 firstcol text-truncate">
    @if (actorInSendgroup.grouped) {
      <span [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample"
        [ngClass]="{'cursor-pointer': !groupedActor }"
        (click)="$event.stopPropagation(); openEmailPreview()">
        {{actorInSendgroup.name}}
      </span>
    }
    @if (!actorInSendgroup.grouped) {
      <span>
        {{actorInSendgroup.name}}
      </span>
    }
  </div>
  <div class="col-2 text-truncate">
    {{getActionsByActor()}}
    @if (actorInSendgroup.countOfAction && actorInSendgroup.countOfAction > 1) {
      <i class="bi" [ngClass]="{ 'bi-caret-down-fill': !isCollapsed, 'bi-caret-up-fill': isCollapsed}"></i>
    }
  </div>
  <div class="col-4 text-truncate">{{getDocumentsByActor()}}</div>
  <div class="col-1 text-truncate">{{getCreditsByActor()}}</div>
  <div class="col-1 text-end">
    <span class="float-end">
      <div class="float-end ms-2 base-font-color"><i class="bi bi-grip-vertical bi-large cursor-change-order"></i>
    </div>
    @if (showMenu) {
      <div class="btn-group">
        <button type="button" class="btn bg-transparent border-0 p-0" (click)="$event.stopPropagation();"
          data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-three-dots bi-large"></i>
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item pt-1 pb-1" (click)="$event.stopPropagation(); openEmailPreview()"
          translate="Button.ShowInvite"></a></li>
        </ul>
      </div>
    }
  </span>
</div>
</div>